import { api } from "../App";
import { SET_SECURITY_LOG, SET_SECURITY_LOG_LOADING, SET_SECURITY_LOG_PAGE, SET_SECURITY_LOG_COUNT } from "./types";
import { itemsOnPage } from "../assets/const";


export const setPage = (pageNumber) => ({ type: SET_SECURITY_LOG_PAGE, payload: pageNumber })


export const getSecurityLogs = (date) => async (dispatch, getState) => {
    const { pageNumber } = getState().security_log

    const max_results = itemsOnPage
    const paginate_from = itemsOnPage * pageNumber
    let params = {
        ...date,
        limit: max_results,
        offset: paginate_from
    }
    const urlParams = new URLSearchParams(params).toString();

    try {
        dispatch({ type: SET_SECURITY_LOG_LOADING, payload: true });
        const { data: { count, result } } = await api.get(`/security_log?${urlParams}`)
        dispatch({ type: SET_SECURITY_LOG, payload: result });
        const pageCount = Math.ceil(count / itemsOnPage)
        dispatch({ type: SET_SECURITY_LOG_COUNT, payload: { pageCount, count } });
    } catch (ERR) {
        console.log(ERR)
    } finally {
        dispatch({ type: SET_SECURITY_LOG_LOADING, payload: false });
    }
};

